export type EventsAction =
  | { type: 'SET_ALL_EVENTS', events: Julius.Website.EventOverviewViewModel[] }
  | { type: 'SET_FILTERED_EVENTS', events: Julius.Website.EventOverviewViewModel[] }
  | { type: 'SET_SEARCHED_EVENTS', events: Julius.Website.EventOverviewViewModel[] }
  | { type: 'SET_IS_FETCHING_ALL_EVENTS' }
  | { type: 'SET_IS_FETCHING_FILTERED_EVENTS' }
  | { type: 'SET_FETCH_ALL_FAILED' }
  | { type: 'SET_FETCH_FILTERED_FAILED' }
  | { type: 'SET_IS_SEARCH_RESULT', isSearchResult: boolean }
  | { type: 'SET_EVENTS_INCREASE_RATIO', ratio: number }
  | { type: 'SET_CATEGORY', id: number }
  | { type: 'SET_FILTER_FIRST_DATE', date: Date }
  | { type: 'SET_FILTER_LAST_DATE', date: Date }
  | { type: 'SET_FILTER_CITY', city: string }
  | { type: 'SET_FILTER_EMPTY' }
  | { type: 'ON_BOX_VIEW_CLICK' }
  | { type: 'ON_LIST_VIEW_CLICK' }
  | { type: 'ON_MORE_EVENTS_CLICK' };

export const setEvents = (events: Julius.Website.EventOverviewViewModel[]): EventsAction => ({
  events,
  type: 'SET_ALL_EVENTS',
});

export const setFilteredEvents = (events: Julius.Website.EventOverviewViewModel[]): EventsAction => ({
  events,
  type: 'SET_FILTERED_EVENTS',
});

export const setSearchedEvents = (events: Julius.Website.EventOverviewViewModel[]): EventsAction => ({
  events,
  type: 'SET_SEARCHED_EVENTS',
});

export const setIsFetchingAllEvents = (): EventsAction => ({
  type: 'SET_IS_FETCHING_ALL_EVENTS',
});

export const setIsFetchingFilteredEvents = (): EventsAction => ({
  type: 'SET_IS_FETCHING_FILTERED_EVENTS',
});

export const setIsSearchResult = (isSearchResult: boolean): EventsAction => ({
  isSearchResult,
  type: 'SET_IS_SEARCH_RESULT',
});

export const setFetchAllFailed = (): EventsAction => ({
  type: 'SET_FETCH_ALL_FAILED',
});

export const setFetchFilteredFailed = (): EventsAction => ({
  type: 'SET_FETCH_FILTERED_FAILED',
});

export const setEventsIncreaseRatio = (ratio: number): EventsAction => ({
  ratio,
  type: 'SET_EVENTS_INCREASE_RATIO',
});

export const setMoreVisibleEvents = (): EventsAction => ({
  type: 'ON_MORE_EVENTS_CLICK',
});

export const setBoxView = (): EventsAction => ({
  type: 'ON_BOX_VIEW_CLICK',
});

export const setListView = (): EventsAction => ({
  type: 'ON_LIST_VIEW_CLICK',
});

export const setCategory = (id: number): EventsAction => ({
  id,
  type: 'SET_CATEGORY',
});

export const setFilterFirstDate = (date: Date): EventsAction => ({
  date,
  type: 'SET_FILTER_FIRST_DATE',
});

export const setFilterLastDate = (date: Date): EventsAction => ({
  date,
  type: 'SET_FILTER_LAST_DATE',
});

export const setFilterCity = (city: string): EventsAction => ({
  city,
  type: 'SET_FILTER_CITY',
});

export const setFilterEmpty = (): EventsAction => ({
  type: 'SET_FILTER_EMPTY',
});



// WEBPACK FOOTER //
// ./src/pages/EventsPage/Redux/actions.tsx